<template>
  <div class="ctrl-facebook-api-history">
    <el-row>
      <el-col>
        <h2>Meta広告 API送信履歴</h2>
      </el-col>
    </el-row>
    <FacebookLogTable :pageType="'ctrl'"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FacebookLogTable from "@/components/Tools02/ApiHistories/FacebookLogTable.vue";

export default {
  components: {
    FacebookLogTable,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rt", "tool"]),
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>